/* eslint-disable react/no-multi-comp */
import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import { RectangleVideo } from '../RectangleVideo/RectangleVideo'
import { SquareVideo } from '../SquareVideo/SquareVideo'
import { BlocksGrid, RectangleImage, SquareImage } from './Layout7.styles'
import type { GridProps, ItemProps, StyledItemProps } from './Layout7.types'

export const Grid = ({ handle, children }: GridProps): JSX.Element => {
  return <BlocksGrid id={handle}>{children}</BlocksGrid>
}

const SquareItem = ({ media }: StyledItemProps): JSX.Element | null => {
  if (!media) {
    return null
  }

  if (media.type === 'image') {
    return (
      <SquareImage
        lqip
        lazyload
        alt={media.alt}
        imgSrc={setQueryParams(media.src, [{ name: 'width', value: '30' }])}
        sources={buildIntrinsicWidthSources({
          src: media.src,
        })}
      />
    )
  }

  return <SquareVideo poster={media.preview} sources={media.sources} />
}

const RectangleItem = ({ media }: StyledItemProps): JSX.Element | null => {
  if (!media) {
    return null
  }

  if (media.type === 'image') {
    return (
      <RectangleImage
        lqip
        lazyload
        alt={media.alt}
        imgSrc={setQueryParams(media.src, [{ name: 'width', value: '30' }])}
        sources={buildIntrinsicWidthSources({
          src: media.src,
        })}
      />
    )
  }

  return <RectangleVideo poster={media.preview} sources={media.sources} />
}

export const Item = ({ media, position }: ItemProps): JSX.Element | null => {
  if (position === 1 || position === 2) {
    return <SquareItem media={media} />
  }
  if (position === 0) {
    return <RectangleItem media={media} />
  }

  return null
}
